import styled from "styled-components";

export const Overlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 66;
  display: flex;
  align-items: flex-end;
`;

export const Backdrop = styled.button`
  position: absolute;
  inset: 0;
  border: none;
  background: transparent;
`;

export const Sheet = styled.div`
  position: relative;
  width: 100%;
  background: #fff;
  border-radius: 16px 16px 0 0;
  padding: 24px 20px 40px;
  max-height: 88vh;
  overflow: auto;
`;

export const DragHandle = styled.div`
  width: 50px;
  height: 4px;
  border-radius: 2px;
  background: #e0e0e0;
  margin: -16px auto 16px;
`;

export const Title = styled.div`
  font-size: 16px;
  font-weight: 700;
  margin-bottom: 45px;
`;

export const HeadingRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 19px;
`;

export const Heading = styled.div`
  font-size: 24px;
  font-weight: 800;
  line-height: 1.2;
`;

export const Icon = styled.img`
  width: 50px;
  height: 60px;
  object-fit: contain;
`;

export const Header = styled.div`
  font-size: 14px;
  color: #6f7d95;
  margin-bottom: 0;
`;

export const SubHeader = styled.div`
  font-size: 14px;
  margin-top: 0;
  margin-bottom: 16px;
`;

export const Description = styled.div`
  font-size: 14px;
  margin-bottom: 16px;
`;

export const Persuasion = styled.div`
  margin: 16px 0;
  border-radius: 16px;
  padding: 16px;
  background: #eefbf2;
  font-size: 14px;
  color: #4b5563;
`;

export const List = styled.div`
  display: grid;
  gap: 8px;
  margin: 0 0 20px;
`;

export const ListItem = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 12px;
`;

export const Bullet = styled.div`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #6f7d95;
  margin-top: 6px;
`;

export const ItemText = styled.div`
  font-size: 14px;
`;

export const ButtonRow = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 16px;
  padding: 0 10px;
  margin-top: 8px;
`;

export const TextBtn = styled.button`
  border: none;
  background: transparent;
  color: #1f59d8;
  font-size: 16px;
  font-weight: 700;
  text-transform: uppercase;
  cursor: pointer;
`;

